import {
  PostEditorReducerFunction,
  PostEditorScheduleAddAction,
  PostEditorScheduleRemoveAction,
  PostEditorScheduleResetAction,
  PostEditorScheduleUpdateAction
} from '../PostEditorActions';
import { OnStateUpdateCallbackFunction, postGroupStateUpdater } from '../../helpers/postGroupStateUpdater';
import { ImmutabilityContext } from '../effects/customImmutabilityContext';
import { ScheduleHelpers } from '../../Schedule/Schedule.helpers';
import { PostEditorErrorKeys } from '../../../../models/validator-props';
import { validatorStateUpdater } from '../../validators/helpers/validatorStateUpdater';
import { ErrorMessageSeverity } from '../../../../constants/form';

const scheduleMainKeys: PostEditorErrorKeys[] = [
  'checkDateAndTime',
  'checkExpiryDate',
  'pinterestDuplicatesCheck',
  'preventTwDuplicate',
  'profileRequired',
  'scheduleTextOrMediaVariations'
];

const scheduleAddRemovekeys: PostEditorErrorKeys[] = [...scheduleMainKeys, 'checkExpiryCount'];

export const scheduledAddReducer: PostEditorReducerFunction<PostEditorScheduleAddAction['payload']> = (
  state,
  payload
) => {
  const { update: updateImmutable } = ImmutabilityContext;
  const { postGroupIndex, date, customizeIndex } = payload;
  const callback: OnStateUpdateCallbackFunction = currentPost =>
    updateImmutable(currentPost, {
      scheduling: {
        scheduledLocalDateTimes: {
          $set: ScheduleHelpers.addAndSortScheduledDates(currentPost.scheduling.scheduledLocalDateTimes, date)
        }
      }
    });
  const result = postGroupStateUpdater(state, postGroupIndex, customizeIndex, 'schedule', callback);
  return validatorStateUpdater(result, postGroupIndex, ErrorMessageSeverity.warning, scheduleAddRemovekeys);
};

export const scheduledRemoveReducer: PostEditorReducerFunction<PostEditorScheduleRemoveAction['payload']> = (
  state,
  payload
) => {
  const { update: updateImmutable } = ImmutabilityContext;
  const { postGroupIndex, scheduledIndex, customizeIndex } = payload;
  const callback: OnStateUpdateCallbackFunction = currentPost =>
    updateImmutable(currentPost, {
      scheduling: {
        scheduledLocalDateTimes: {
          $splice: [[scheduledIndex, 1]]
        }
      }
    });
  const result = postGroupStateUpdater(state, postGroupIndex, customizeIndex, 'schedule', callback);
  return validatorStateUpdater(result, postGroupIndex, ErrorMessageSeverity.warning, scheduleAddRemovekeys);
};

export const scheduledResetReducer: PostEditorReducerFunction<PostEditorScheduleResetAction['payload']> = (
  state,
  payload
) => {
  const { update: updateImmutable } = ImmutabilityContext;
  const { postGroupIndex, customizeIndex } = payload;
  const callback: OnStateUpdateCallbackFunction = currentPost =>
    updateImmutable(currentPost, {
      scheduling: {
        scheduledLocalDateTimes: {
          $set: []
        }
      }
    });
  const result = postGroupStateUpdater(state, postGroupIndex, customizeIndex, 'schedule', callback);
  return validatorStateUpdater(result, postGroupIndex, ErrorMessageSeverity.warning, scheduleAddRemovekeys);
};

export const scheduledUpdateReducer: PostEditorReducerFunction<PostEditorScheduleUpdateAction['payload']> = (
  state,
  payload
) => {
  const { update: updateImmutable } = ImmutabilityContext;
  const { postGroupIndex, scheduledIndex, date, customizeIndex } = payload;
  const callback: OnStateUpdateCallbackFunction = currentPost =>
    updateImmutable(currentPost, {
      scheduling: {
        scheduledLocalDateTimes: {
          $set: ScheduleHelpers.updateAndSortScheduledDates(
            currentPost.scheduling.scheduledLocalDateTimes,
            date,
            scheduledIndex
          )
        }
      }
    });
  const result = postGroupStateUpdater(state, postGroupIndex, customizeIndex, 'schedule', callback);
  return validatorStateUpdater(result, postGroupIndex, ErrorMessageSeverity.warning, [...scheduleMainKeys]);
};
